import { Form } from "react-bootstrap";
import "./form.css";
import { useState, useEffect } from "react";

const FormUnit = (props) => {


  return (
    <Form.Group controlId="formName">
      <Form.Label>
        <b>{props.title}</b>
      </Form.Label>
      <Form.Control
        type={props.type}
        name={props.name}
        placeholder={props.placeholder}
        required={props.required}
        disabled={props.disabled}
        value={props.value}
        onChange={props.handleChange}
      />
    </Form.Group>
  );
};

export default FormUnit;